import { isMobile } from '../../../actions/more/utils';

export const stringifyFontObject = ({ fontObj }) => {
  if (!fontObj || !fontObj.style) {
  }
  return `\
    ${
      fontObj && fontObj.style && fontObj.style.italic ? 'italic' : 'normal'
    } normal\
    ${fontObj && fontObj.style && fontObj.style.bold ? 'bold' : 'normal'}
    ${
      fontObj && fontObj.isSettings ? fontObj.fontSizeForSettings : fontObj.size
    }px/1.2em\
    ${fontObj && fontObj.family ? fontObj.family : 'inherit'}\
    `;
};

export const stringifyTextDecoration = ({ fontObj }) =>
  fontObj && fontObj.style && fontObj.style.underline ? 'underline' : 'none';

export const isIGTVMedia = (media) => {
  media = (media && media.originalData) || media;
  return (
    media && media.media_product_type && media.media_product_type === 'IGTV'
  );
};

export const isVideoMedia = (media) => {
  media = (media && media.originalData) || media;
  return media && media.media_type === 'VIDEO';
};

export const getMediaId = (index, medias) => {
  if (medias.length && medias.length > index && index >= 0) {
    return medias[index].originalData?.id || medias[index].id;
  }
};

export const playMobileVideos = (vidRefs, albumIndex, isPlaying) => {
  if (Object.keys(vidRefs).length) {
    for (const key in vidRefs) {
      if (key == albumIndex && isPlaying) {
        vidRefs[key].play();
      } else {
        vidRefs[key].currentTime = 0;
        vidRefs[key].pause();
      }
    }
  }
};

export const isVideoPlaying = (videoElement) =>
  !!(
    videoElement.currentTime > 0 &&
    !videoElement.paused &&
    !videoElement.ended &&
    videoElement.readyState > 2
  );

export const setIGTV = (video, callback) => {
  video.onloadedmetadata = function () {
    video && video.duration >= 61 && callback(true);
  };
};

export const checkIfiOS = () => {
  return (
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
    ].includes(navigator.platform) ||
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  );
};

export const iOSUserApproval = (ref) => {
  if (checkIfiOS && ref) {
    ref.current.play().then(() => {
      ref.current.pause();
      ref.current.currentTime = 0;
    });
  }
};

export const getScaleValue = (mediaToShowRef) => {
  const windowHeight = window.innerHeight;
  const windowWidth = window.innerWidth;
  const EXPAND_HEIGHT = 600;
  const EXPAND_WIDTH = 980;
  const SPACE = 48;
  let scaleHeight = 0;
  let scaleWidth = 0;
  // Check Height
  if (windowHeight <= EXPAND_HEIGHT + SPACE * 2) {
    scaleHeight = (windowHeight - SPACE * 2) / EXPAND_HEIGHT;
  }
  // Check Width
  if (windowWidth <= EXPAND_WIDTH + SPACE * 2) {
    scaleWidth = (windowWidth - SPACE * 2) / EXPAND_WIDTH;
  }
  // Get accurate width if ref element exists
  if (mediaToShowRef && mediaToShowRef.current) {
    const mediaToShowWidth = mediaToShowRef.current.clientWidth;
    if (windowWidth <= mediaToShowWidth + SPACE * 2) {
      scaleWidth = (windowWidth - SPACE * 2) / mediaToShowWidth;
    }
  }

  let minScale;
  if (scaleHeight || scaleWidth) {
    if (!scaleHeight) {
      minScale = scaleWidth;
    } else if (!scaleWidth) {
      minScale = scaleHeight;
    } else {
      minScale = Math.min(scaleHeight, scaleWidth);
    }
    return { transform: `scale(${minScale})` };
  } else {
    return {};
  }
};
